export const quiz_it =  {
  "general": {
    "title": "I diritti dei bambini in ospedale e durante le visite mediche",
    "intro": "Quali affermazioni sono corrette? Clicca su di esse! Attenzione: Diverse risposte possono essere corrette!",
    "finishButton": "Controllare le risposte",
    "nrQuestions": 7,
    "maxPoints": 35,
    "resultTitle": "ce l'hai fatta!",
    "resultText": "Hai risposto correttamente a <correctQuestions> domande su <questions> e quindi hai ottenuto <points> punti su <pointsMax> .",
    "button_back": "indietro",
    "button_forward": "prosegui"
  },
  "questions": [
    {
      "question": "Devo sempre essere curato in ospedale quando sono malato?",
      "picture": "",
      "answers": [
        "Sì, un ospedale pediatrico è il posto migliore per i bambini malati!",
        "In base alla gravità dei sintomi, può essere sufficiente una visita medica; il ricovero in ospedale non è sempre necessario.",
        "È importante verificare se esistono delle alternative al ricovero ospedaliero. Ad esempio, l'assistenza domiciliare pediatrica o il trattamento in una clinica diurna."
      ],
      "correctAnswer": [1,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "In ospedale molte cose sono strane e poco familiari. Cosa può aiutarti a sentirti più sicuri?",
      "picture": "",
      "answers": [
        "Sono accompagnato da una persona di fiducia.",
        "Mi sono fatto spiegare tutto nei dettagli.",
        "Porterò con me il mio peluche preferito."
      ],
      "correctAnswer": [0,1,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Chi vi aiuterà se avete paura o avete domande in ospedale?",
      "picture": "",
      "answers": [
        "I miei genitori o una persona di riferimento possono essere quasi sempre con me, anche di notte o prima di un'operazione, indipendentemente dall'età.",
        "Va bene avere paura. Ne parlo. Tutti in ospedale mi aiutano a sentirmi meglio.",
        "Ehi, sono già grande e posso fare tutto da solo!"
      ],
      "correctAnswer": [0,1],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Gli adulti possono sempre decidere quale sia il trattamento migliore per te?",
      "picture": "",
      "answers": [
        "No! Ho il diritto di fare delle domande e di ottenere spiegazioni. Voglio capire tutto.",
        "No! Se non voglio un trattamento, lo dico. Questo deve essere rispettato.",
        "Sì, gli adulti possono sempre decidere come sono trattato."
      ],
      "correctAnswer": [0,1],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Devi fare tutto quello che dicono i medici e i tuoi genitori?",
      "picture": "",
      "answers": [
        "No, la mia opinione è importante! Lo dico quando qualcosa è sgradevole o se non voglio qualcosa.",
        "Sì, certo! Certo che i miei genitori e i medici sanno sempre cosa è meglio per me.",
        "No. Ad esempio, posso chiedere agli adulti di uscire dalla stanza quando mi cambio."
      ],
      "correctAnswer": [0,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Se devi rimanere in ospedale per molto tempo, ti sdrai a letto tutto il tempo?",
      "picture": "",
      "answers": [
        "Certo! E' fantastico!",
        "No. È importante che io abbia l'opportunità di giocare o di imparare.",
        "No, durante le lunghe degenze l'ospedale farà in modo che possiate studiare, ad esempio in una scuola ospedaliera."
      ],
      "correctAnswer": [1,2],
      "point": 5,
      "evaluate": true
    },
    {
      "question": "Sei in ospedale nello stesso reparto degli adulti?",
      "picture": "",
      "answers": [
        "No, i bambini vengono curati in un ospedale pediatrico o in un reparto pediatrico.",
        "Sì, è la cosa più semplice da fare.",
        "No. Facciano in modo che i bambini della stessa età stiano insieme."
      ],
      "correctAnswer": [0,2],
      "point": 5,
      "evaluate": true
    },
  ]
} 